import gql from 'graphql-tag';

const CREATE_SALESFORCE_OPPORTUNITY_LINE_ITEMS = gql`
  mutation CreateSalesforceOpportunityLineItems(
    $opportunityId: String!
    $lineItems: [SalesforceLineItemInput!]!
  ) {
    createSalesforceOpportunityLineItems(
      opportunityId: $opportunityId
      lineItems: $lineItems
    )
  }
`;

export default CREATE_SALESFORCE_OPPORTUNITY_LINE_ITEMS;
